export default __webpack_public_path__ + "static/media/self-learning-webinar.89ee8c0b.png";